var map = {
	"./cluedo.png": 827,
	"./portfolio.png": 208,
	"./todoApp.png": 314,
	"assets/images/cluedo.png": 827,
	"assets/images/portfolio.png": 208,
	"assets/images/todoApp.png": 314
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 180;